import GalleryImage1 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-in-dungeon-with-submissive-on-cross.jpg';
import GalleryImage2 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-outside.jpg';
import GalleryImage3 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-smoking-outside.jpg';
import GalleryImage4 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-on-sofa-with-whip.jpg';
import GalleryImage5 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-in-garden.jpg';
import GalleryImage6 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-towering-over-sissy.jpg';
import GalleryImage7 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-with-green-flail.jpg';
import GalleryImage8 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-and-friends-playing-with-sub.jpg';

import { CompanyName } from '../Constants';

import Image1 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-and-friend-playing-with-happy-sub.jpg';
import Image2 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-and-friends-playing-with-sub.jpg';
import Image3 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-crouched-outside.jpg';
import Image4 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-in-dungeon-with-racked-sub.jpg';
import Image5 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-in-dungeon-with-submissive-on-cross.jpg';
import Image6 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-in-garden.jpg';
import Image7 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-in-kitchen-stockings.jpg';
import Image8 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrixin-the-kitchen.jpg';
import Image9 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-main-image.jpg';
import Image10 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-on-sofa-with-whip.jpg';
import Image11 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-outside.jpg';
import Image12 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-outside-crouched-smoking.jpg';
import Image13 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-outside-sitting-with-whip.jpg';
import Image14 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-outside-with-ass-towards-camera.jpg';
import Image15 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-smoking-outside.jpg';
import Image16 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-towering-over-sissy.jpg';
import Image17 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-with-green-flail.jpg';

export const galleryImagesArray = [
  { id: 1, src: Image1, alt: `${CompanyName} with a happy sub`, name: 'Happy Sub', date: 'March 1, 2025' },
  { id: 2, src: Image10, alt: `${CompanyName} playing with friends and a sub`, name: 'Friends and Sub', date: 'March 2, 2025' },
  { id: 3, src: Image2, alt: `${CompanyName} crouched outside`, name: 'Outdoor Crouch', date: 'March 3, 2025' },
  { id: 4, src: Image4, alt: `${CompanyName} with a racked sub in the dungeon`, name: 'Dungeon Racked Sub', date: 'March 4, 2025' },
  { id: 5, src: Image5, alt: `${CompanyName} with a sub on the cross`, name: 'Sub on Cross', date: 'March 5, 2025' },
  { id: 6, src: Image6, alt: `${CompanyName} in a garden`, name: 'Garden Scene', date: 'March 6, 2025' },
  { id: 7, src: Image7, alt: `${CompanyName} in the kitchen with stockings`, name: 'Kitchen Stockings', date: 'March 7, 2025' },
  { id: 8, src: Image8, alt: `${CompanyName} in the kitchen`, name: 'Kitchen Pose', date: 'March 8, 2025' },
  { id: 9, src: Image9, alt: `${CompanyName} main image`, name: 'Main Image', date: 'March 9, 2025' },
  { id: 10, src: Image3, alt: `${CompanyName} on a sofa with a whip`, name: 'Sofa with Whip', date: 'March 10, 2025' },
  { id: 11, src: Image11, alt: `${CompanyName} outside`, name: 'Outdoor Pose', date: 'March 11, 2025' },
  { id: 12, src: Image12, alt: `${CompanyName} crouching and smoking outside`, name: 'Crouching & Smoking', date: 'March 12, 2025' },
  { id: 13, src: Image13, alt: `${CompanyName} sitting with a whip outside`, name: 'Outdoor Whip', date: 'March 13, 2025' },
  { id: 14, src: Image14, alt: `${CompanyName} with her back to the camera`, name: 'Back Pose', date: 'March 14, 2025' },
  { id: 15, src: Image15, alt: `${CompanyName} smoking outside`, name: 'Smoking Outside', date: 'March 15, 2025' },
  { id: 16, src: Image16, alt: `${CompanyName} towering over a sissy`, name: 'Towering Over', date: 'March 16, 2025' },
  { id: 17, src: Image17, alt: `${CompanyName} with a green flail`, name: 'Green Flail', date: 'March 17, 2025' },
];


// Image Data Array
export const smallGalleryImagesArray = [
  {
    id: 1,
    src: GalleryImage1,
    name: 'Dungeon Control',
    alt: `${CompanyName} dominating in her dungeon with a submissive on the cross`,
    ariaLabel: 'Gallery image 1',
  },
  {
    id: 2,
    src: GalleryImage2,
    name: 'Commanding Presence',
    alt: `${CompanyName} standing outside, exuding authority`,
    ariaLabel: 'Gallery image 2',
  },
  {
    id: 3,
    src: GalleryImage3,
    name: 'Smoking Seduction',
    alt: `${CompanyName} enjoying a smoke with a commanding gaze`,
    ariaLabel: 'Gallery image 3',
  },
  {
    id: 4,
    src: GalleryImage4,
    name: 'Sofa Dominance',
    alt: `${CompanyName} lounging with a whip in hand`,
    ariaLabel: 'Gallery image 4',
  },
  {
    id: 5,
    src: GalleryImage5,
    name: 'Garden Enigma',
    alt: `${CompanyName} posing in a lush outdoor setting`,
    ariaLabel: 'Gallery image 5',
  },
  {
    id: 6,
    src: GalleryImage6,
    name: 'Towering Over Power',
    alt: `${CompanyName} asserting dominance over a submissive`,
    ariaLabel: 'Gallery image 6',
  },
  {
    id: 7,
    src: GalleryImage7,
    name: 'Flail of Authority',
    alt: `${CompanyName} wielding a green flail with commanding energy`,
    ariaLabel: 'Gallery image 7',
  },
  {
    id: 8,
    src: GalleryImage8,
    name: 'Crouched Power',
    alt: `${CompanyName} crouched outside, radiating dominance`,
    ariaLabel: 'Gallery image 8',
  },
];